<template>
  <div class="toast">
    {{ list.msg }}
  </div>
</template>
<script>
export default {
  props: ["list"]
};
</script>
<style scoped>
.toast {
  box-sizing: border-box;
  padding: 12px 20px;
  border-radius: 12px;
  background-color: black;
  color: #fff;
  text-align: center;
  line-height: 24px;
  font-size: 16px;
  font-weight: 400px;
  white-space: nowrap;
  display: flex;
  gap: 8px;
}
</style>
